import React from "react";

const FormattedResponse = ({ response, className }) => {
  return (
    <div className={`p-4 rounded-lg border-2 ${className}`}>
      <div className="text-lg font-medium text-gray-800">{response}</div>
    </div>
  );
};

export default FormattedResponse;
